<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'workbench',
})
</script>
<!-- @format -->

<template>
	<div :class="isHeight ? 'workbench isHeight' : 'workbench'">
		<el-row class="workbenchAll">
			<div class="edit-btn">
				<el-button
					v-if="hasButtonPermission('system:template:adminEdit') && adminEditStatus"
					@click="handleClick(props.moduleType, true)"
				>
					编辑模版(通用)
				</el-button>
				<el-button
					v-if="hasButtonPermission('system:template:edit') && editStatus"
					@click="handleClick(props.moduleType, false)"
				>
					编辑模版(个人)
				</el-button>
			</div>
			<!-- <el-button
				v-if="!router.currentRoute.value.query.type"
				style="text-align: end"
				type="primary"
				@click="onClickEdit"
				>编辑</el-button
			> -->
			<!-- 自定义布局项 -->
			<div v-if="isEdit" class="top">
				<el-row>
					<el-col :span="9">
						<el-select
							v-model="selectValue.value"
							class="selectTemplate"
							placeholder="模板切换"
							size="default"
							style="width: 240px; margin-right: 10px"
							@change="onChangeSelect"
						>
							<el-option
								v-for="item in selectValue.list"
								:key="item.templateId"
								:label="
									isAdmin
										? item.templateDefault !== '0'
											? item.templateName
											: item.templateName + '（默认）'
										: item.templateDefault == '0' && item.individuation == 'system'
										? item.templateName + '（默认）'
										: item.templateName
								"
								:value="item.templateId"
							/>
						</el-select>
						<span v-if="isAdmin" class="switchTemplate"
							>启用：<el-switch v-model="switchStatus.value" @change="onChangeSwitch"
						/></span>
						<span v-if="isAdmin" class="switchTemplate"
							>默认模板：<el-switch v-model="switchStatus.default" @change="onChangeDefault"
						/></span>
					</el-col>
					<el-col v-show="!editNameStatus.isEdit" class="topCenter" :span="6">
						{{ templateInfo.templateName
						}}{{
							isAdmin
								? templateInfo.templateDefault !== '0'
									? ''
									: '（默认）'
								: templateInfo.templateDefault == '0' && templateInfo.individuation == 'system'
								? '（默认）'
								: ''
						}}
						<el-tooltip v-if="isAdmin" content="修改名称" placement="top">
							<el-icon class="editName" @click="onClickIconEdit"><icon-ant-design:edit-outlined /></el-icon>
						</el-tooltip>
						<el-tooltip content="预览" placement="top">
							<el-icon class="editName" @click="onClickPreview"><icon-ant-design:eye-outlined /></el-icon>
						</el-tooltip>
						<el-tooltip v-if="isAdmin" content="删除" placement="top">
							<el-icon class="editName" @click="onDeleteTemplate"><icon-ant-design:delete-outlined /></el-icon>
						</el-tooltip>
					</el-col>
					<el-col v-show="editNameStatus.isEdit" class="topCenter" :span="6">
						<el-input
							ref="templateInputName"
							v-model="editNameStatus.name"
							class="selectTemplate"
							maxlength="15"
							show-word-limit
							placeholder="请输入模板名称"
							style="width: 240px"
							@keyup.enter="onInputBlur"
							@blur="onInputBlur"
						/>
					</el-col>
					<el-col class="topButton" :span="9">
						<el-button v-if="isAdmin" type="primary" style="border-radius: 1px" @click="onClickAdd">新增模板</el-button>
						<el-button type="primary" style="border-radius: 1px" @click="onClickSave">保存</el-button>
						<!-- <el-button class="delButton" @click="onClickGoBack">返回</el-button> -->
						<el-button @click="onClickReset">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<div style="width: 100%" :class="isEdit ? 'workbenchEdit' : ''">
				<div v-if="isEdit">
					<el-menu default-active="2" class="el-menu-vertical-demo" :collapse="isCollapse">
						<div>
							<div class="head-title">
								<span>可用模块</span>
							</div>
							<div class="leftList">
								<div v-for="item in initPanelsLayout" :key="item.i" class="listItem">
									<el-button
										:draggable="!item.isSelect"
										:class="item.isSelect ? 'itemButton' : 'itemButton overButton'"
										type="primary"
										:style="{ minWidth: isCollapse ? '0px' : '80px' }"
										@dragstart="(e) => dragstart(e, item)"
									>
										{{ !isCollapse ? item.name : item.name.slice(0, 1) + `...` }}
									</el-button>
								</div>
							</div>
						</div>
						<div style="text-align: center; cursor: pointer" @click="isCollapse = !isCollapse">
							<el-icon :size="18"><Operation /></el-icon>
						</div>
					</el-menu>
				</div>
				<div :class="isEdit ? 'right' : ''">
					<div ref="targetContent" class="rightPanel">
						<grid-layout
							ref="gridLayoutRef"
							:layout="getSelectedModule(initPanelsLayout)"
							:col-num="24"
							:row-height="rowHeight"
							:is-draggable="isEdit"
							:is-resizable="isEdit"
							:is-mirrored="false"
							:vertical-compact="false"
							:margin="[10, 10]"
							:use-css-transforms="true"
						>
							<grid-item
								v-for="item in getSelectedModule(initPanelsLayout)"
								:key="item.i"
								:x="item.isSelect ? item.x : 0"
								:y="item.isSelect ? item.y : 0"
								:w="item.isSelect ? item.w : 0"
								:h="item.isSelect ? item.h : 0"
								:i="item.isSelect ? item.i : 0"
								:min-w="item.minW"
								:min-h="item.minH"
								:static="item.static"
								@resized="resizedEvent(item)"
							>
								<component
									:is="(componentsObj && componentsObj[item.url]) || getWidgetName(item.url)"
									v-if="item.isSelect && !item.closedState"
									:id="item.i"
									:item="item"
									:is-workbenchedit="isEdit"
									:is-height="isHeight"
									:service-height="serviceHeight"
									:edit-array="item.editArray"
									:url="item.url"
									@select-item-event="selectItemEvent"
									@delete-panel-item-event="onDeletePanel"
								>
								</component>
								<div
									v-if="
										item.isSelect &&
										!item.closedState &&
										!((componentsObj && componentsObj[item.url]) || getWidgetName(item.url))
									"
									:id="item.i"
									class="itemBox work-img-border"
								>
									<div v-if="isEdit" class="delIcon">
										<el-icon @click="onDeletePanel(item.i)"><icon-ant-design:delete-outlined /></el-icon>
									</div>
									<iframe :src="item.url" frameborder="no" style="width: 100%; height: 100%" scrolling="auto" />
								</div>
							</grid-item>
						</grid-layout>
					</div>
				</div>
			</div>
		</el-row>
		<el-dialog
			v-model="templateStatus.visible"
			:close-on-click-modal="false"
			title="请新增模板"
			width="40%"
			:before-close="() => onClickClose('cancel')"
		>
			<el-row class="addTemplate">
				<el-col :span="8" style="text-align: right"> 模板名称： </el-col>
				<el-col :span="8">
					<el-input v-model="templateStatus.name" maxlength="15" show-word-limit placeholder="请输入模板名称" />
				</el-col>
			</el-row>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="onClickClose('cancel')">取消</el-button>
					<el-button type="primary" @click="onClickClose('confirm')">确定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script setup name="workbench" lang="ts">
	import { useGlobalStoreWithOut, hasButtonPermission } from '@power/runtime-vue3';
	import { getWidgetName, comAttr } from './components';
	import { Storage } from '@/utils';
	import { useMenuStoreWithOut } from '@/store/modules/menu';
	import {
		templateList,
		getTemplateInfo,
		addTemplate,
		editTemplate,
		removeTemplate,
		userAddTemplate,
	} from '@/api/powercess/workbench';
	import { getModuleList } from '@/api/system/module';
	import { getInfo } from '@/api/workbenchAll';
	import { PcModal as $modal } from '@/components';

	interface Props {
		moduleType: String; //模块类型
		envUrl: String; //VITE_BASE_URL路径
		componentsObj?: any;
		componentsSetting?: any;
	}

	const router = useRouter();

	const isCollapse = ref(true);

	const type = router.currentRoute.value.params.type;

	const isEdit = ref(type === 'edit' || type === 'adminEdit');

	const isAdmin = ref(type === 'adminEdit');

	const props = withDefaults(defineProps<Props>(), {});

	const { proxy }: any = getCurrentInstance();

	const globalStore = useGlobalStoreWithOut();

	const initPanelsLayout = ref<any>([]);

	const serviceHeight = ref<any>('');

	const editNameStatus = ref({
		isEdit: false,
		name: '',
	});

	const isHeight = ref(false);

	const switchStatus = ref<any>({
		value: false,
		default: false,
	});

	const rowHeight = ref(-7);

	const dragItem = ref<any>({});

	const selectValue = ref<any>({
		value: '',
		list: [],
	});

	const templateStatus = ref<any>({
		name: '',
		visible: false,
	});

	const templateInfo = ref<any>({});

	const gridLayoutRef = ref<any>();

	// const onClickEdit = () => {
	// 	router.push({
	// 		path: router.currentRoute.value.path,
	// 		query: {
	// 			type: 'edit',
	// 		},
	// 	});
	// };

	const menuStore = useMenuStoreWithOut();

	const list = computed(() => {
		return menuStore.menusRes.find(
			(item) =>
				!item.hidden &&
				item.resourceType === 'menu' &&
				item.defaultUrl.includes('workbenchAll') &&
				item.alias === props.moduleType,
		);
	});

	const adminEditStatus = computed(() => {
		return menuStore.menusRes.some(
			(item) =>
				item?.parentId === list.value.id && item.apiPermissions && item.apiPermissions === 'system:template:adminEdit',
		);
	});

	const editStatus = computed(() => {
		return menuStore.menusRes.some(
			(item) =>
				item?.parentId === list.value.id && item.apiPermissions && item.apiPermissions === 'system:template:edit',
		);
	});

	// 查询模块渲染时是否是已选择的模块
	const getSelectedModule = (templatelist) => {
		const newList: any = [];
		for (let i = 0; i < templatelist.length; i++) {
			if (templatelist[i].isSelect) {
				newList.push(templatelist[i]);
			}
		}
		return newList;
	};

	const onClickReset = () => {
		getPanelsLayout(selectValue.value.value);
	};

	// 编辑名字失去焦点时
	const onInputBlur = () => {
		if (editNameStatus.value.name == templateInfo.value.templateName) {
			editNameStatus.value.isEdit = false;
		} else {
			templateInfo.value.templateName = editNameStatus.value.name;
			editTemplate(templateInfo.value).then(() => {
				getPanelsLayout(selectValue.value.value);
				getAddTemplateList();
				editNameStatus.value.isEdit = false;
				$modal.msgSuccess('修改成功');
			});
		}
	};

	// 点击图标编辑名字
	const onClickIconEdit = () => {
		editNameStatus.value = {
			isEdit: true,
			name: templateInfo.value.templateName,
		};
		proxy.$refs['templateInputName'].focus();
	};

	// 点击预览模板
	const onClickPreview = () => {
		window.sessionStorage.setItem('previewWorkbench', JSON.stringify(initPanelsLayout.value));
		window.sessionStorage.setItem('workbenchName', JSON.stringify(templateInfo.value.templateName));
		const url = `${props.envUrl}workbenchAll/${props.moduleType}/preview`;
		window.open(url);
	};

	async function getPanelsLayout(getInfoid) {
		const res = await getModuleList({ type: props.moduleType });
		const res1: any = await getInfo();
		console.log(res1, 121);

		initPanelsLayout.value = [];
		const datas: any = [];
		const empowerData = res.data;
		if (empowerData && empowerData.length) {
			for (let i = 0; i < empowerData.length; i++) {
				if (empowerData[i].status === '0') {
					const obj =
						comAttr[empowerData[i].parameters] ||
						(props.componentsSetting && props.componentsSetting[empowerData[i].parameters]);
					if (obj) {
						datas.push({
							x: obj.x,
							y: obj.y,
							w: obj.w,
							h: obj.h,
							i: empowerData[i].moduleId,
							minW: obj.minW,
							minH: obj.minH,
							name: empowerData[i].moduleName,
							url: empowerData[i].parameters,
							isSelect: false,
							editArray: [],
						});
					} else {
						datas.push({
							x: 0,
							y: 0,
							w: 8,
							h: 146,
							i: empowerData[i].moduleId,
							minW: 0,
							minH: 0,
							name: empowerData[i].moduleName,
							url: empowerData[i].parameters,
							isSelect: false,
							isExternalurl: true,
						});
					}
				}
			}
		}

		console.log(datas, '99999');
		const resModules = await getTemplateInfo(getInfoid);
		templateInfo.value = resModules.data;

		switchStatus.value = {
			value: templateInfo.value.status == '0' ? true : false,
			default: templateInfo.value.templateDefault == '0' ? true : false,
		};
		if (templateInfo.value.parameters) {
			const parameters = JSON.parse(templateInfo.value.parameters);
			for (let i = 0; i < parameters.length; i++) {
				let isParameters = true;
				for (let j = 0; j < datas.length; j++) {
					if (`${parameters[i].i}` == datas[j].i) {
						if (parameters[i].url === '/workbench/myService') {
							serviceHeight.value = parameters[i].h;
						}

						parameters[i].closedState = false;
						if (datas[j].url !== parameters[i].url) {
							parameters[i].url = datas[j].url;
						}
						datas[j] = parameters[i];
						isParameters = false;
					}
				}
				if (isParameters) {
					parameters[i].closedState = true;
					datas.push(parameters[i]);
				}
			}
		}

		initPanelsLayout.value = datas;
		getModuleData();
	}

	// 选择模板调接口
	const onChangeSelect = () => {
		getPanelsLayout(selectValue.value.value);
	};

	// 模板状态启用
	const onChangeSwitch = (val) => {
		templateInfo.value.status = val ? '0' : '1';
		if (templateInfo.value.templateDefault == '0' && templateInfo.value.status == '1') {
			switchStatus.value.value = true;
			$modal.msgWarning('此模板为默认模板，不可停用!');
			return;
		} else {
			editTemplate(templateInfo.value).then(() => {
				getPanelsLayout(selectValue.value.value);
				if (val) {
					$modal.msgSuccess('启用成功');
				} else {
					$modal.msgSuccess('停用成功');
				}
			});
		}
	};

	// 默认模板启用
	const onChangeDefault = (val) => {
		if (!val) {
			switchStatus.value.default = true;
			$modal.msgWarning('此模板已设为默认模板，不可重复设置!');
			return;
		} else {
			templateInfo.value.templateDefault = val ? '0' : '1';
			templateInfo.value.status = '0';
			editTemplate(templateInfo.value).then(() => {
				getPanelsLayout(selectValue.value.value);
				getAddTemplateList();
				$modal.msgSuccess('默认模板设置成功');
			});
		}
	};

	const getModuleData = () => {
		const res = globalStore.subSystems;
		let userService: any = [];
		userService = res.map((item) => item.name);
		for (let i = 0; i < initPanelsLayout.value.length; i++) {
			if (initPanelsLayout.value[i].name == '切换应用空间') {
				initPanelsLayout.value[i].editArray = userService;
			}
		}
		// 类型列表
		// workflowTypes().then((res) => {
		// 	const data = res.data.map((item) => item.code);
		// 	for (let i = 0; i < initPanelsLayout.value.length; i++) {
		// 		if (initPanelsLayout.value[i].url === '/workbench/calendar' && !initPanelsLayout.value[i].editArray.length) {
		// 			initPanelsLayout.value[i].editArray = data;
		// 		}
		// 	}
		// });
	};

	async function getList() {
		if (type !== 'preview') {
			getTemplateList();
		} else if (type === 'preview') {
			initPanelsLayout.value = JSON.parse(window.sessionStorage.getItem('previewWorkbench') || '');
		}
	}

	//获取模板列表
	const getTemplateList = () => {
		const params: any = {
			type: props.moduleType,
			individuation: isAdmin.value ? 'system' : 'user',
		};
		if (!isAdmin.value) {
			params.status = '0';
			params.userAccount = Storage.get('userAccount');
		}
		templateList(params).then((res) => {
			selectValue.value.list = res;
			let isHaveUser = false;

			if (isAdmin.value) {
				res.map((item) => {
					if (item.templateDefault == '0' && item.individuation == 'user') {
						selectValue.value.value = item.templateId;
						isHaveUser = true;
					}
				});
			}
			if (isHaveUser) {
				getPanelsLayout(selectValue.value.value);
			} else {
				res.map((item) => {
					if (item.templateDefault == '0') {
						selectValue.value.value = item.templateId;
						getPanelsLayout(item.templateId);
					}
				});
			}
		});
	};

	//获取添加模板列表
	const getAddTemplateList = () => {
		templateList({
			type: props.moduleType,
			individuation: 'system',
		}).then((res) => {
			selectValue.value.list = res;
		});
	};

	// 鼠标拖拽
	function dragstart(_e, item) {
		dragItem.value = item;
		if (dragItem.value.url === '/workbench/myService') {
			serviceHeight.value = dragItem.value.h;
			dragItem.value.minH = 70;
		}
		// 设置元素的放置行为——移动
		proxy.$refs['targetContent'].addEventListener('dragenter', dragenter);
		// 在目标元素经过 必须要阻止默认行为 否则不能触发drop
		proxy.$refs['targetContent'].addEventListener('dragover', dragover);
		// 离开目标元素时设置元素的放置行为——不能拖放
		proxy.$refs['targetContent'].addEventListener('dragleave', dragleave);
		// 拖动元素在目标元素松手时添加元素到画布
		proxy.$refs['targetContent'].addEventListener('drop', drop);
	}

	function dragenter(e) {
		e.dataTransfer.dropEffect = 'move';
	}

	function dragover(e) {
		e.preventDefault();
	}

	function dragleave(e) {
		e.dataTransfer.dropEffect = 'none';
	}

	function drop() {
		initPanelsLayout.value.map((item) => {
			if (item.name === dragItem.value.name) {
				item.isSelect = true;
			}
		});
	}

	// 新增模板
	const onClickAdd = () => {
		templateStatus.value.visible = true;
	};

	const handleClick = (alias: String, isEdit: boolean) => {
		const url = `${props.envUrl}workbenchAll/${alias}/${isEdit ? 'adminEdit' : 'edit'}`;
		window.open(url);
	};

	// 关闭选择模板的模态框
	const onClickClose = (type) => {
		if (type === 'cancel') {
			templateStatus.value = {
				name: '',
				visible: false,
			};
		} else if (type === 'confirm') {
			if (templateStatus.value.name) {
				const onetemplate = {
					individuation: 'system',
					templateName: templateStatus.value.name,
					type: props.moduleType,
					userAccount: Storage.get('userAccount'),
				};
				addTemplate(onetemplate).then((res) => {
					templateStatus.value = {
						name: '',
						visible: false,
					};
					selectValue.value.value = res.data;
					getAddTemplateList();
					getPanelsLayout(res.data);
					$modal.msgSuccess('提交成功');
				});
			} else {
				$modal.msgWarning('请输入模板名称!');
				return;
			}
		}
	};

	// 保存模板
	const onClickSave = () => {
		const saneTemplate: any = [];
		for (let i = 0; i < initPanelsLayout.value.length; i++) {
			if (initPanelsLayout.value[i].isSelect) {
				saneTemplate.push(initPanelsLayout.value[i]);
			}
		}
		if (isAdmin.value) {
			templateInfo.value.parameters = saneTemplate.length ? JSON.stringify(saneTemplate) : '';
			editTemplate(templateInfo.value).then(() => {
				getPanelsLayout(selectValue.value.value);
				$modal.msgSuccess('保存成功');
			});
		} else {
			const onetemplate = {
				individuation: 'user',
				parameters: saneTemplate.length ? JSON.stringify(saneTemplate) : '',
				templateName: '个性化模板',
				type: props.moduleType,
				userAccount: Storage.get('userAccount'),
				templateDefault: '0',
			};

			$modal
				.msgConfirm('是否保存并返回工作台？')
				.then(function () {
					return userAddTemplate(onetemplate).then((res) => {
						selectValue.value.value = res.data;
					});
				})
				.then(() => {
					$modal.msgSuccess('保存成功');
					getPanelsLayout(selectValue.value.value);
					window.location.href = `${props.envUrl}workbenchAll/${props.moduleType}`;
					// getTemplateList();
				})
				.catch(() => {});
		}
	};

	// 删除模板
	const onDeleteTemplate = () => {
		if (templateInfo.value.templateDefault == '0') {
			$modal.msgWarning('此模板为默认模板，不可删除!');
			return;
		} else {
			$modal
				.msgConfirm('请确认是否删除该模板吗？')
				.then(() => {
					removeTemplate(templateInfo.value.templateId).then(() => {
						$modal.msgSuccess('删除成功');
						getTemplateList();
					});
				})
				.catch(() => {});
		}
	};

	// 删除面板
	const onDeletePanel = (panelId) => {
		const deleteName: any = [];
		const layout: any = Array.from(initPanelsLayout.value);
		for (const attr in layout) {
			if (layout[attr].i === panelId) {
				deleteName.push(layout[attr].name);
				layout[attr].isSelect = false;
			}
		}
		initPanelsLayout.value = layout.filter((item) => {
			if (item !== undefined) {
				return item;
			}
		});
	};

	// 根据面板配置数据
	function selectItemEvent(select) {
		for (let i = 0; i < initPanelsLayout.value.length; i++) {
			if (initPanelsLayout.value[i].i == select.module) {
				initPanelsLayout.value[i].editArray = select.selectList;
			}
		}
	}

	const onSetRem = () => {
		const clientHeight = document.documentElement.clientHeight;
		const clientWidth = document.documentElement.clientWidth;

		if (clientHeight > 200) {
			isHeight.value = true;
			const designSize = 1920; // 设计图尺寸
			const sizeHeight = (document.documentElement.style.fontSize = ((clientWidth / designSize) * 10) as any);
			document.documentElement.style.fontSize = `${(clientWidth / designSize) * 10}px`;

			if (sizeHeight * 0.3 - 10 > -7.5) {
				rowHeight.value = sizeHeight * 0.3 - 10;
			} else {
				rowHeight.value = 2.5 - 10;
			}
		} else {
			isHeight.value = false;
		}
	};

	const resizedEvent = (item) => {
		const ev = new Event('resize');
		if (item.url === '/workbench/myService') {
			serviceHeight.value = item.h;
			item.minH = 60;
		}

		window.dispatchEvent(ev);
	};

	// 改变窗口大小时重新计算
	window.onresize = function () {
		onSetRem();
	};

	onMounted(() => {
		onSetRem();
		getList();
		getTemplateList();
	});

	watch(
		() => router.currentRoute.value.params,
		() => {
			window.location.reload();
		},
		{
			deep: true,
		},
	);
</script>

<style scoped lang="scss">
	.el-menu-vertical-demo {
		background: var(--theme-workbench-background-color);
		margin-left: 4px;
		padding: 10px 0;
		padding-bottom: 20px;
		border-radius: 4px;
		height: calc(100vh - 55px - 96px);
		margin-top: 10px;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
	}

	.el-menu-vertical-demo.el-menu--collapse {
		width: 64px;
	}

	.head-title {
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 32px;
		font-weight: bold;
	}

	.leftList {
		.listItem {
			height: 50px;
			line-height: 50px;
			text-align: center;

			.itemButton {
				width: 70%;
				height: 40px;
				font-weight: 600;
			}

			.overButton {
				color: #005bb8;
				background: none;
				border: 1px solid #005bb8;
				font-weight: 600;
			}
		}
	}

	.workbench {
		background-size: 100% 100%;
		position: relative;

		.icon-box {
			position: absolute;
			top: 0px;
			right: 0px;
			left: 0;
			bottom: 0;
			opacity: 0.8;

			.box {
				display: flex;
				justify-content: center;
				align-items: center;
				height: 90%;
				flex-direction: column;

				img {
					width: 230px;
				}
			}

			.name {
				font-size: 28px;
				color: #ffffff;
				line-height: 34px;
			}
		}

		.workbenchAll {
			// padding-right: 12px;
			height: 100%;
			background-color: var(--theme-bg-color);

			.edit-btn {
				position: absolute;
				top: 10px;
				right: 20px;
				z-index: 100;
				width: 270px;
				height: 45px;
				text-align: right;

				.el-button {
					display: none;
				}

				&:hover .el-button {
					display: inline-block;
				}
			}

			.top {
				position: absolute;
				z-index: 1001;
				width: 100%;
				font-size: 18px;
				height: 50px;
				line-height: 50px;
				background: var(--theme-workbench-background-color);
				padding: 0 10px;

				.switchTemplate {
					font-size: 14px;
					display: inline-block;
					margin-left: 10px;
				}

				.topButton {
					text-align: right;

					.delButton {
						color: #005bb8;
						background: none;
						border: 1px solid #005bb8;
						border-radius: 1px;
					}
				}

				.topCenter {
					display: flex;
					justify-content: center;
					align-items: center;

					.editName {
						color: var(--el-color-primary);
						font-size: 22px;
						margin-left: 15px;
						cursor: pointer;
					}
				}
			}

			.workbenchEdit {
				height: 100%;
				background-color: var(--theme-bg-color);
				padding-top: 50px;
				display: flex;

				.el-menu-vertical-demo:not(.el-menu--collapse) {
					width: 200px;
					background: var(--theme-workbench-background-color);
					margin-left: 4px;
					padding: 10px;
					padding-bottom: 20px;
					border-radius: 4px;
					height: calc(100vh - 55px - 96px);
					margin-top: 10px;
					overflow-y: auto;

					.head-title {
						font-size: 16px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						line-height: 32px;
						font-weight: bold;
					}

					.leftList {
						.listItem {
							height: 50px;
							line-height: 50px;
							text-align: center;

							.itemButton {
								width: 70%;
								height: 40px;
								font-weight: 600;
							}

							.overButton {
								color: #005bb8;
								background: none;
								border: 1px solid #005bb8;
								font-weight: 600;
							}
						}
					}
				}

				.right {
					// width: 85%;
					flex: 1;
					// margin-left: 15%;
					height: calc(100vh - 90px - 50px);

					.rightPanel {
						height: 100%;
						overflow: auto;

						.itemBox {
							width: 100%;
							height: 100%;
							position: relative;

							:deep .el-loading-mask {
								margin-top: 40px;
							}

							.delIcon {
								position: absolute;
								display: inline-block;
								width: 100%;
								height: 100%;
								line-height: 30px;
								padding-right: 10px;
								right: 3px;
								top: 5px;
								text-align: right;
								font-size: 18px;
								z-index: 99;

								.el-icon {
									color: #333;
									cursor: pointer;
								}
							}
						}

						.closedState {
							:deep .el-loading-mask {
								.el-loading-spinner {
									top: 40%;
								}
							}

							.delIcon {
								width: 100%;
								right: 0;
								height: 40px;
								line-height: 40px;
							}
						}
					}
				}
			}

			.addTemplate {
				align-items: center;
			}
		}

		:deep .el-input__wrapper {
			border-radius: 1px;
		}
	}

	.isHeight {
		// height: 100%;

		.workbenchAll {
			height: 100%;
		}

		.itemBox {
			width: 100%;
			height: 100%;
			position: relative;
		}

		.closedState {
			:deep .el-loading-mask {
				.el-loading-spinner {
					top: 40%;
				}
			}
		}
	}

	:deep .el-transfer {
		text-align: center;
	}
</style>
